import { app } from '../../app.module'
// TikTok投稿平均データ
interface ITikTokPostAverageData {
  plays: number
  likes: number
  comments: number
  shares: number
  collects: number
  engagements: number
  engagementRates: number
}

/**
 * TikTok投稿テーブルの平均
 * @class PostTikTokTableAverageComponentCtrl
 */
class PostTikTokTableAverageComponentCtrl {
  // 平均データ
  private averageData: ITikTokPostAverageData
  // 平均データビュー
  private averageDataView: ITikTokPostAverageData
  // 投稿数
  private postsCount: number

  constructor() {
    this.averageDataView = {
      plays: 0,
      likes: 0,
      comments: 0,
      shares: 0,
      collects: 0,
      engagements: 0,
      engagementRates: 0,
    }
  }

  /**
   * 平均データが変更時、平均を算出
   */
  public $onChanges(): void {
    this.caculateAverage()
  }

  /**
   * 平均を算出
   * @private
   * @returns {void}
   */
  private caculateAverage(): void {
    this.averageDataView = {
      plays: 0,
      likes: 0,
      comments: 0,
      shares: 0,
      collects: 0,
      engagements: 0,
      engagementRates: 0,
    }
    if (this.postsCount === 0 || this.postsCount === undefined || this.postsCount === null) {
      return
    }

    this.averageDataView.plays = this.averageData.plays / this.postsCount
    this.averageDataView.likes = this.averageData.likes / this.postsCount
    this.averageDataView.comments = this.averageData.comments / this.postsCount
    this.averageDataView.shares = this.averageData.shares / this.postsCount
    this.averageDataView.collects = this.averageData.collects / this.postsCount
    this.averageDataView.engagements = this.averageData.engagements / this.postsCount
    this.averageDataView.engagementRates =
      (this.averageData.engagements / this.averageData.plays) * 100
  }
}

app.component('postTiktokTableAverage', {
  bindings: {
    averageData: '<',
    postsCount: '<',
  },
  template: require('./post-tiktok-table-average.pug')(),
  controller: PostTikTokTableAverageComponentCtrl,
})
